import HeroSection from '../sections/HeroSection'
import ResourceCrisisSection from '../sections/ResourceCrisisSection'
import ProductsSection from '../sections/ProductsSection'
import TechnicalCoreSection from '../sections/TechnicalCoreSection'
import MarketFitROISection from '../sections/MarketFitROISection'
import WhyInvestSection from '../sections/WhyInvestSection'
import NextStepSection from '../sections/NextStepSection'

const Home = () => {
  return (
    <main>
      <HeroSection />
      <ResourceCrisisSection />
      <ProductsSection />
      <TechnicalCoreSection />
      <MarketFitROISection />
      <WhyInvestSection />
      <NextStepSection />
    </main>
  )
}

export default Home
